import { render, staticRenderFns } from "./AppSubjectTemplatesView.vue?vue&type=template&id=078f140c"
import script from "./AppSubjectTemplatesView.vue?vue&type=script&lang=ts"
export * from "./AppSubjectTemplatesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports